// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {

        if (!document.querySelectorAll('.search__form-filters-label' ).length ) {
            return;
        }

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        const filters = { 
            s: params.s,
            'search-news': params["search-news"],
            'search-page': params["search-page"],
            'search-degree': params["search-degree"],
            'search-department': params["search-department"],
            'search-person': params["search-person"],
        };

        $('.search__form-filters-label > a').on('click', function( e ) {
            e.preventDefault();

            const closest = $(this).closest('[data-open]');
            closest.attr('data-open', closest.attr('data-open') != "true");
        });

        document.querySelectorAll('.search__form-filters-clear, .search__results-filters-clear').forEach($el => $el.addEventListener( 'click', e => {
            e.preventDefault();

            if (!filters.s) {
                return;
            }

            window.location.href = "?s=" + filters.s;
        } ) );

        document.querySelectorAll('.search__form-filters-boxes input').forEach($el => $el.addEventListener('change', (e) => {

            if (!filters.s) {
                return;
            }

            const value = e.target.checked ? 1 : 0;
            const key = e.target.getAttribute('name');
            
            filters[key] = value;
            let url = [];

            Object.keys(filters).forEach(f=> {
                if( filters[f] ) {
                    url.push(`${f}=${filters[f]}`);
                }
            })

            window.location.href = '?' + url.join('&');
        }));

        document.querySelectorAll('.search__results-filter').forEach($el => $el.addEventListener('click', (e) => {
            e.preventDefault();

            if (!filters.s) {
                return;
            }

            const key = $el.getAttribute('data-filter');

            filters[key] = false;
            let url = [];

            Object.keys(filters).forEach(f => {
                if (filters[f]) {
                    url.push(`${f}=${filters[f]}`);
                }
            })

            window.location.href = '?' + url.join('&');
        }));

    }, false);

})(jQuery);